"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    SearchInput: {
      position: 'relative',
      display: 'flex'
    },
    Input: {
      '&, &[type], &[disabled], &[readonly], &[type][disabled], &[type][readonly]': {
        width: '100%',
        paddingRight: 64,
        boxSizing: 'border-box'
      }
    },
    ButtonContainer: {
      position: 'absolute',
      right: 0,
      top: 0,
      display: 'flex'
    },
    SearchButton: {
      fontSize: 16,
      height: 32,
      width: 32,
      background: 'none',
      border: 'none',
      borderRadius: 6,
      cursor: 'pointer',
      '&.active': {
        background: theme['$button-primary-color-active'],
        color: theme['$background-color']
      }
    },
    SearchClear: {
      fontSize: 16,
      height: 32,
      width: 32,
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    },
    Disabled: {
      opacity: 0.3
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map